import { useEffect, useState } from 'react'
import * as Sentry from '@sentry/react-native'
import { aiAssistantsApi, httpStatusOf } from './aiAssistantsApi'
import { reportsInfoFailure, showsAiAssistantsEntry } from './aiAssistantsView'

/**
 * ATL-1694 — whether this organization can connect an AI assistant now, for the entry points that
 * should exist only then (Settings → AI assistants, the help button on API tokens). An organization
 * still reading Firestore can never connect one, so it is not asked; anything but a "yes" from the
 * server — dark, not allowlisted, could not check, failed — is `false`.
 */
export const useAiAssistantsAvailable = (organizationReadsSupabase: boolean, organizationId: string | null | undefined): boolean => {
  const [available, setAvailable] = useState(false)

  useEffect(() => {
    setAvailable(false)
    if (!organizationReadsSupabase) return undefined
    let cancelled = false
    aiAssistantsApi
      .info()
      .then((info) => {
        if (!cancelled) setAvailable(showsAiAssistantsEntry(info))
      })
      .catch((error: unknown) => {
        if (!cancelled && reportsInfoFailure(httpStatusOf(error))) {
          Sentry.captureException(error, { tags: { feature: 'ai-assistants' } })
        }
      })
    return () => {
      cancelled = true
    }
    // Keyed on the organization too: a super-admin switching organizations keeps this screen mounted,
    // and the previous organization's "yes" must not carry over (nor its late answer land).
  }, [organizationReadsSupabase, organizationId])

  return available
}
